(function () {
  if (window.__shopSearchKeywordsBooted) return;
  window.__shopSearchKeywordsBooted = true;

  window.__SHOP_SEARCH_TRENDS__ = window.__SHOP_SEARCH_TRENDS__ || {
    supabaseUrl: 'https://ozddinkzagrabhjziczu.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96ZGRpbmt6YWdyYWJoanppY3p1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMTI5OTksImV4cCI6MjEwMDg4ODk5OX0.T6IsiUcCtbAQMxEZY--FfnMtk76D-h8_fty1V-J_qjc'
  };

  var SUGGEST_DEBOUNCE_MS = 80;
  var SUGGEST_DEBOUNCE_PROVISIONAL_MS = 45;
  var INGEST_DEBOUNCE_MS = 3000;
  var INGEST_MAX_TITLES = 40;
  var KEYWORD_SUGGEST_LIMIT = 15;
  var PRODUCT_SUGGEST_LIMIT = 4;
  var SUGGEST_CACHE_SESSION_KEY = 'figusen_suggest_cache_v1';
  var SUGGEST_CACHE_SESSION_MAX = 48;
  var suggestTimer = null;
  var suggestSeq = 0;
  var suggestCache = {};
  var suggestWarmStarted = false;
  var suggestWarmQueue = [];
  var historyCloudTimer = null;
  var historyCloudReady = false;
  var FALLBACK_WARM_PREFIXES = [
    'ご',
    'そ',
    'る',
    'な',
    'み',
    'ごじ',
    'ごく',
    'そん',
    'MSP',
    'SMSP',
    'ワンピース',
    'ドラゴン',
    '五条',
    'ルフィ',
    '孫悟',
    'バーダ',
    'るふ',
    'きめ',
    'じゅじ'
  ];
  var ingestTimer = null;
  var ingestSent = {};
  var HISTORY_KEY = 'figusen_search_history';
  var HISTORY_LIMIT = 20;
  var LOCAL_LEARN_KEY = 'figusen_local_suggest_learn';
  var LOCAL_LEARN_LIMIT = 200;
  var touchSuggestGuardUntil = 0;
  var lastSuggestPickAt = 0;
  // Mercari-like sticky dismiss after outside tap.
  // Windows IME often keeps focus and fires compositionend — must not reopen.
  // Cleared only by explicit tap on the search input (not by focus/compositionend).
  var suggestClosedByOutside = false;
  var outsideCloseLockUntil = 0;
  var suggestFetchGen = 0;
  // While navigating from a suggest pick, force all search inputs to this label
  // so late IME compositionend cannot re-append typed leftovers (e.g. "そ").
  var lockedPickQuery = '';

  function lockSearchInputsToQuery(q) {
    var label = String(q || '').trim();
    if (!label) return;
    lockedPickQuery = label;
    window.__shopSuggestNavigating = true;
    window.__shopPickedQuery = label;
    document.querySelectorAll('.header-shop-search__input, predictive-search input[type="search"], input[name="q"]').forEach(function (el) {
      try {
        if (el.getAttribute && el.getAttribute('data-search-q') === null && el.name !== 'q' && !el.classList.contains('header-shop-search__input')) {
          return;
        }
      } catch (e0) {}
      try {
        el.blur();
      } catch (e1) {}
      el.value = label;
      try {
        el.setAttribute('value', label);
      } catch (e2) {}
    });
  }

  function reassertLockedPickQuery() {
    if (!window.__shopSuggestNavigating || !lockedPickQuery) return;
    document.querySelectorAll('.header-shop-search__input, predictive-search input[type="search"]').forEach(function (el) {
      if (el.value !== lockedPickQuery) el.value = lockedPickQuery;
    });
  }

  function isCoarsePointer() {
    try {
      return !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
    } catch (e) {
      return 'ontouchstart' in window;
    }
  }

  function markTouchSuggestGuard() {
    touchSuggestGuardUntil = Date.now() + 500;
  }

  function isTouchSuggestGuarded() {
    return Date.now() < touchSuggestGuardUntil;
  }

  function syncSuggestDismissGlobals() {
    window.__shopSuggestForceClosed = suggestClosedByOutside;
    window.__shopSuggestGhostBlockUntil = suggestClosedByOutside ? Date.now() + 60000 : 0;
  }

  function clearSuggestDismissed(forceClear) {
    // Ignore accidental focus/composition clears right after outside tap
    if (!forceClear && Date.now() < outsideCloseLockUntil) return;
    suggestClosedByOutside = false;
    outsideCloseLockUntil = 0;
    syncSuggestDismissGlobals();
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      try {
        ps.removeAttribute('data-shop-suggest-dismissed');
        if (ps.predictiveSearchResults) {
          ps.predictiveSearchResults.style.removeProperty('display');
        }
      } catch (e) {}
    });
  }

  function markSuggestDismissed() {
    suggestClosedByOutside = true;
    // Mobile IME often fires late compositionend/focus after outside tap
    outsideCloseLockUntil = Date.now() + (isCoarsePointer() ? 900 : 550);
    syncSuggestDismissGlobals();
    suggestFetchGen += 1;
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      try {
        ps.setAttribute('data-shop-suggest-dismissed', '');
      } catch (e) {}
    });
  }

  function isSuggestDismissed() {
    return suggestClosedByOutside;
  }

  function shouldBlockGhostReopen() {
    return suggestClosedByOutside;
  }

  function forceCloseSuggestPanel(ps) {
    if (!ps) return;
    try {
      ps.isComposing = false;
      clearSuggestSelection(ps, { refocus: false, activate: false });
      setSuggestInputActive(ps, false);
      if (typeof ps.close === 'function') ps.close(false);
      ps.removeAttribute('open');
      ps.removeAttribute('loading');
      // Only keep CSS lock while outside-dismiss is active
      if (suggestClosedByOutside) {
        ps.setAttribute('data-shop-suggest-dismissed', '');
        if (ps.predictiveSearchResults) {
          ps.predictiveSearchResults.style.display = 'none';
        }
      } else if (ps.predictiveSearchResults) {
        ps.predictiveSearchResults.style.removeProperty('display');
      }
    } catch (e) {}
  }

  // While closed-by-outside, strip any [open] that compositionend tries to set
  function installSuggestDismissGuard() {
    if (window.__shopSuggestDismissGuard) return;
    window.__shopSuggestDismissGuard = true;
    var obs = new MutationObserver(function () {
      if (!suggestClosedByOutside) return;
      document.querySelectorAll('predictive-search[open], predictive-search[loading]').forEach(forceCloseSuggestPanel);
    });
    function watchAll() {
      document.querySelectorAll('predictive-search').forEach(function (ps) {
        try {
          obs.observe(ps, { attributes: true, attributeFilter: ['open', 'loading'] });
        } catch (e) {}
      });
    }
    watchAll();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchAll);
    }
  }

  function cfg() {
    return window.__SHOP_SEARCH_TRENDS__ || {};
  }

  function supaBase() {
    return String(cfg().supabaseUrl || '').replace(/\/$/, '');
  }

  function apiHeaders() {
    var key = String(cfg().supabaseKey || '').trim();
    return {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + key,
      apikey: key
    };
  }

  function toKatakana(str) {
    return String(str || '').replace(/[\u3041-\u3096]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) + 0x60);
    });
  }

  function normalizeJa(str) {
    return toKatakana(String(str || '').normalize('NFKC'))
      .toLowerCase()
      .replace(/[ﾞﾟ]/g, '')
      .replace(/[\s　・･\-_/／\\|｜]/g, '');
  }

  // Same query shape for suggest tap and typed submit → SERP
  function normalizeSearchQuery(term) {
    var t = String(term || '')
      .replace(/[☆★]/g, '')
      .replace(/【[^】]*】/g, ' ')
      .replace(/[\s　]+/g, ' ')
      .trim();
    t = cleanFigureLabel(t);
    // Drop listing noise so SERP matches suggest keywords more closely
    var noise =
      /^(国内正規品|正規品|中古|未開封|開封済|送料込|送料無料|美品|新品|箱あり|箱無し|箱なし|フィギュアショップ|破壊王子|一番くじ付き|特典付き)$/i;
    t = splitTerms(t)
      .filter(function (part) {
        return part && !noise.test(part);
      })
      .join(' ');
    return t.trim();
  }

  function searchUrlFor(term) {
    var q = normalizeSearchQuery(term);
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function splitTerms(str) {
    return String(str || '')
      .trim()
      .split(/[\s　]+/)
      .filter(Boolean);
  }

  function customerIdForHistory() {
    try {
      var cfgBb = window.__buybackNotificationConfig || {};
      if (cfgBb.shopifyCustomerId != null && cfgBb.shopifyCustomerId !== '') {
        return String(cfgBb.shopifyCustomerId);
      }
    } catch (e0) {}
    try {
      if (window.Shopify && window.Shopify.customerId) return String(window.Shopify.customerId);
    } catch (e1) {}
    return '';
  }

  function loadSuggestCacheFromSession() {
    try {
      var raw = sessionStorage.getItem(SUGGEST_CACHE_SESSION_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return;
      Object.keys(parsed).forEach(function (k) {
        if (!suggestCache[k] && Array.isArray(parsed[k]) && parsed[k].length) {
          suggestCache[k] = parsed[k];
        }
      });
    } catch (e) {}
  }

  function persistSuggestCacheToSession() {
    try {
      var keys = Object.keys(suggestCache);
      if (!keys.length) return;
      var out = {};
      var i;
      for (i = keys.length - 1; i >= 0 && Object.keys(out).length < SUGGEST_CACHE_SESSION_MAX; i--) {
        var k = keys[i];
        if (suggestCache[k] && suggestCache[k].length) out[k] = suggestCache[k];
      }
      sessionStorage.setItem(SUGGEST_CACHE_SESSION_KEY, JSON.stringify(out));
    } catch (e) {}
  }

  function mergeHistoryLists(primary, secondary) {
    var out = [];
    var seen = {};
    function pushAll(list) {
      (list || []).forEach(function (item) {
        var q = String(item || '').trim();
        if (!q) return;
        var k = q.toLowerCase();
        if (seen[k]) return;
        seen[k] = true;
        out.push(q);
      });
    }
    pushAll(primary);
    pushAll(secondary);
    return out.slice(0, HISTORY_LIMIT);
  }

  function writeLocalHistory(list) {
    try {
      localStorage.setItem(HISTORY_KEY, JSON.stringify((list || []).slice(0, HISTORY_LIMIT)));
    } catch (e) {}
  }

  function scheduleHistoryCloudPush() {
    var cid = customerIdForHistory();
    if (!cid) return;
    clearTimeout(historyCloudTimer);
    historyCloudTimer = setTimeout(function () {
      pushHistoryToCloud(cid, getSearchHistory());
    }, 400);
  }

  function pushHistoryToCloud(cid, list) {
    var base = supaBase();
    if (!base || !cid) return;
    fetch(base + '/rest/v1/rpc/put_customer_search_history', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        p_customer_id: String(cid),
        p_labels: (list || []).slice(0, HISTORY_LIMIT)
      }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function syncHistoryFromCloud() {
    var cid = customerIdForHistory();
    var base = supaBase();
    if (!cid || !base || historyCloudReady) return;
    historyCloudReady = true;
    fetch(base + '/rest/v1/rpc/get_customer_search_history', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({ p_customer_id: String(cid) }),
      mode: 'cors'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('history');
        return res.json();
      })
      .then(function (data) {
        var remote = Array.isArray(data) ? data : [];
        var merged = mergeHistoryLists(getSearchHistory(), remote);
        writeLocalHistory(merged);
        // Push union so other devices get local-only items too
        pushHistoryToCloud(cid, merged);
      })
      .catch(function () {});
  }

  function getSearchHistory() {
    try {
      var list = JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      return list
        .map(function (item) {
          return String(item || '').trim();
        })
        .filter(Boolean)
        .slice(0, HISTORY_LIMIT);
    } catch (e) {
      return [];
    }
  }

  function addSearchHistory(query) {
    var q = String(query || '').trim();
    if (!q) return;
    try {
      var list = getSearchHistory().filter(function (item) {
        return item.toLowerCase() !== q.toLowerCase();
      });
      list.unshift(q);
      writeLocalHistory(list);
      scheduleHistoryCloudPush();
    } catch (e) {}
  }

  function clearSearchHistory() {
    try {
      localStorage.removeItem(HISTORY_KEY);
      scheduleHistoryCloudPush();
    } catch (e) {}
  }

  function removeSearchHistoryItem(query) {
    var q = String(query || '').trim();
    if (!q) return;
    try {
      var list = getSearchHistory().filter(function (item) {
        return item.toLowerCase() !== q.toLowerCase();
      });
      writeLocalHistory(list);
      scheduleHistoryCloudPush();
    } catch (e) {}
  }

  function historyRowHtml(label, index) {
    var safe = escapeHtml(label);
    return (
      '<li id="predictive-search-option-history-' +
      (index + 1) +
      '" class="predictive-search__list-item shop-search-history__list-item" role="option" aria-selected="false">' +
      '<div class="shop-search-history__row">' +
      '<a href="' +
      escapeHtml(searchUrlFor(label)) +
      '" class="predictive-search__item predictive-search__item--query predictive-search__item--history link link--text" tabindex="-1">' +
      '<span class="shop-search-history__icon" aria-hidden="true">' +
      queryIconSvg() +
      '</span>' +
      '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
      '<p class="predictive-search__item-heading h5" title="' +
      safe +
      '">' +
      safe +
      '</p>' +
      '</div>' +
      '</a>' +
      '<button type="button" class="shop-search-history__remove" data-search-history-remove="' +
      safe +
      '" aria-label="' +
      safe +
      'を履歴から削除" tabindex="-1">×</button>' +
      '</div></li>'
    );
  }

  // Per-device personalization (v1 local learning restored for RANKING only)
  function getLocalLearnMap() {
    try {
      var raw = JSON.parse(localStorage.getItem(LOCAL_LEARN_KEY) || '{}');
      return raw && typeof raw === 'object' ? raw : {};
    } catch (e) {
      return {};
    }
  }

  function saveLocalLearnMap(map) {
    try {
      var keys = Object.keys(map);
      if (keys.length > LOCAL_LEARN_LIMIT) {
        keys
          .sort(function (a, b) {
            return (map[b].w || 0) - (map[a].w || 0);
          })
          .slice(LOCAL_LEARN_LIMIT)
          .forEach(function (k) {
            delete map[k];
          });
      }
      localStorage.setItem(LOCAL_LEARN_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function bumpLocalLearn(query, searchSource) {
    var q = String(query || '').trim();
    if (q.length < 1) return;
    var src = String(searchSource || 'typed');
    var weight = 1;
    if (src === 'suggest') weight = 5;
    else if (src === 'history') weight = 2;
    else if (src === 'product') weight = 2;

    var map = getLocalLearnMap();
    var now = Date.now();

    function bumpOne(label, w) {
      var key = normalizeJa(label);
      if (!key || key.length < 1) return;
      if (!map[key]) map[key] = { label: String(label).trim(), w: 0, t: now };
      map[key].w += w;
      map[key].t = now;
      map[key].label = String(label).trim() || map[key].label;
    }

    bumpOne(q, weight);
    splitTerms(q).forEach(function (tok) {
      if (tok.length >= 2) bumpOne(tok, weight);
    });
    saveLocalLearnMap(map);
  }

  function localSuggestScore(label, rawInput) {
    var nk = normalizeJa(label);
    if (!nk) return 0;
    var map = getLocalLearnMap();
    var score = 0;
    var key;
    var prefix = normalizeJa(String(rawInput || '').trim().split(/[\s　]+/)[0] || '');
    var head = normalizeJa(String(label || '').trim().split(/[\s　]+/)[0] || '');

    // Prefer display/head starting with typed prefix (ゴジ→ゴジータ over 五条悟)
    if (prefix) {
      if (nk.indexOf(prefix) === 0) score += 80;
      else if (head.indexOf(prefix) === 0) score += 70;
    }

    for (key in map) {
      if (!Object.prototype.hasOwnProperty.call(map, key)) continue;
      var row = map[key];
      var w = row && row.w ? row.w : 0;
      if (!w) continue;
      if (nk === key) score += w * 12;
      else if (nk.indexOf(key) === 0) score += w * 7;
      else if (key.indexOf(nk) === 0 && nk.length >= 1) score += w * 4;
      else if (nk.indexOf(key) !== -1 && key.length >= 2) score += w * 2;
    }

    getSearchHistory().forEach(function (h, i) {
      var hk = normalizeJa(h);
      if (!hk) return;
      if (nk === hk) score += 48 - i * 3;
      else if (nk.indexOf(hk) === 0 || hk.indexOf(nk) === 0) score += 28 - i * 2;
    });

    return score;
  }

  function applyLocalSuggestRank(entries, rawInput) {
    if (!entries || !entries.length) return entries || [];
    // Rank only — do not drop same-head labels (keep full candidate list)
    return entries
      .map(function (entry, index) {
        return {
          entry: entry,
          index: index,
          score: localSuggestScore(entry.label, rawInput)
        };
      })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.index - b.index;
      })
      .map(function (row) {
        return row.entry;
      });
  }

  function seedLocalLearnFromHistory() {
    try {
      if (localStorage.getItem(LOCAL_LEARN_KEY)) return;
      getSearchHistory().forEach(function (q, i) {
        bumpLocalLearn(q, 'history');
        // older history slightly less — bumpLocalLearn already same weight; ok
      });
    } catch (e) {}
  }

  function isSearchEmpty(ps) {
    if (ps && ps.__shopHasContent && ps.__shopHasContent()) return false;
    var raw = getRawFromInstance(ps);
    return !String(raw || '').trim();
  }

  function postSearchRecord(query, searchSource) {
    var base = supaBase();
    var q = String(query || '').trim();
    if (q.length < 2) return;
    bumpLocalLearn(q, searchSource);
    if (!base) return;
    fetch(base + '/rest/v1/rpc/record_search', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        query: q,
        search_source: String(searchSource || 'typed')
      }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function postSearchMiss(query) {
    var base = supaBase();
    if (!base) return;
    var q = String(query || '').trim();
    if (q.length < 2) return;
    fetch(base + '/rest/v1/rpc/record_search_miss', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({ query: q }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function postIngestTitles(titles) {
    var base = supaBase();
    if (!base || !titles || !titles.length) return;
    var unique = [];
    var seen = {};
    titles.forEach(function (t) {
      var title = String(t || '').trim();
      if (title.length < 2) return;
      var key = normalizeJa(title);
      if (!key || seen[key] || ingestSent[key]) return;
      seen[key] = true;
      ingestSent[key] = true;
      unique.push(title);
    });
    if (!unique.length) return;
    fetch(base + '/rest/v1/rpc/ingest_search_titles', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({ titles: unique.slice(0, INGEST_MAX_TITLES) }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function scheduleVisibleTitleIngest() {
    clearTimeout(ingestTimer);
    ingestTimer = setTimeout(collectAndIngestVisibleTitles, INGEST_DEBOUNCE_MS);
  }

  function collectAndIngestVisibleTitles() {
    var titles = [];
    document
      .querySelectorAll(
        '.card__heading a, .card-wrapper .full-unstyled-link, .product-card-wrapper a, .product-grid .card__information h3 a'
      )
      .forEach(function (link) {
        var text = (link.textContent || '').trim();
        if (text.length >= 2 && text.length <= 120) titles.push(text);
      });
    postIngestTitles(titles);
  }

  function postSuggestImpressions(labels) {
    var base = supaBase();
    if (!base || !labels || !labels.length) return;
    var uniq = [];
    var seen = {};
    labels.forEach(function (lab) {
      var t = String(lab || '').trim();
      if (t.length < 2) return;
      var k = normalizeJa(t);
      if (!k || seen[k]) return;
      seen[k] = true;
      uniq.push(t);
    });
    if (!uniq.length) return;
    fetch(base + '/rest/v1/rpc/bump_search_suggest_impressions', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({ labels: uniq.slice(0, 20) }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function isFigureShortPrefix(token) {
    var n = normalizeJa(token);
    return n === normalizeJa('ふぃ') || n === normalizeJa('ふい') || n === normalizeJa('フィ') || n === 'figu';
  }

  function isFigureRelatedLabel(label) {
    var t = String(label || '').trim();
    var n = normalizeJa(t);
    if (n === normalizeJa('フィギュア')) return true;
    if (n.indexOf(normalizeJa('フィギュア')) >= 0) return true;
    if (t === 'スケールフィギュア' || t === '美少女フィギュア' || t === 'デフォルメ') return true;
    return false;
  }

  function isShortKeywordLabel(label) {
    var t = String(label || '').trim();
    if (t.length < 1) return false;
    // Full product SKU names only — long anime / character / brand stay
    if (/[☆★]/.test(t)) return false;
    if (/(国内正規品|中古|未開封|開封済|送料込|送料無料|フィギュアショップ|破壊王子)/.test(t)) return false;
    if (t.length > 80) return false;
    var parts = t.split(/[\s　]+/).filter(Boolean);
    if (parts.length > 6) return false;
    return true;
  }

  function cleanFigureLabel(label) {
    return String(label || '')
      .replace(/(\s*フィギュア)+/g, ' フィギュア')
      .replace(/[\s　]+/g, ' ')
      .trim();
  }

  function hasFigureToken(label) {
    return normalizeJa(label).indexOf(normalizeJa('フィギュア')) !== -1;
  }

  function parseSuggestItems(data, rawInput) {
    var items = (data && data.items) || [];
    var seen = {};
    var entries = [];
    var raw = String(rawInput || '').trim();
    var rawParts = raw.split(/[\s　]+/).filter(Boolean);
    var last = rawParts.length ? rawParts[rawParts.length - 1] : '';
    var tailIsFullFigure = normalizeJa(last) === normalizeJa('フィギュア');
    var figureMode =
      (rawParts.length <= 1 && isFigureShortPrefix(raw)) ||
      (rawParts.length >= 2 && isFigureShortPrefix(last) && !tailIsFullFigure);
    var head = rawParts.length >= 2 ? rawParts.slice(0, -1).join(' ') : '';

    items.forEach(function (row) {
      var label = cleanFigureLabel(row.label);
      if (!label || !isShortKeywordLabel(label)) return;
      if (/フィギュア\s+フィギュア/.test(label)) return;
      var key = normalizeJa(label);
      if (!key || seen[key]) return;
      seen[key] = true;
      entries.push({ label: label, url: searchUrlFor(label) });
    });

    // Ensure フィギュア for short ふぃ only — never when head already has フィギュア
    if (figureMode && head && !hasFigureToken(head)) {
      var combo = cleanFigureLabel(head + ' フィギュア');
      var comboKey = normalizeJa(combo);
      if (!seen[comboKey]) {
        entries.unshift({ label: combo, url: searchUrlFor(combo) });
        seen[comboKey] = true;
      }
    } else if (figureMode && rawParts.length <= 1) {
      var onlyFigKey = normalizeJa('フィギュア');
      if (!seen[onlyFigKey]) {
        entries.unshift({ label: 'フィギュア', url: searchUrlFor('フィギュア') });
        seen[onlyFigKey] = true;
      }
    }

    return entries;
  }

  var suggestAbort = null;

  function suggestCacheKey(raw) {
    return (
      String(raw || '')
        .replace(/[\s　]+/g, ' ')
        .toLowerCase() + (/[\s　]$/.test(String(raw || '')) ? '\t1' : '\t0')
    );
  }

  // Instant paint from a shorter cached prefix (same labels filtered; network still refreshes)
  function provisionalSuggestFromCache(raw, limit) {
    var lim = Math.min(Math.max(limit || KEYWORD_SUGGEST_LIMIT, 8), 15);
    var key = suggestCacheKey(raw);
    if (suggestCache[key] && suggestCache[key].length) {
      return applyLocalSuggestRank(suggestCache[key].slice(), raw).slice(0, lim);
    }
    if (/[\s　]$/.test(String(raw || ''))) return null;
    var trimmed = String(raw || '').trim();
    // Allow 1-char provisional when we have a warm prefix cache (faster feel on slow net)
    if (trimmed.length < 1) return null;
    var prefN = normalizeJa(trimmed);
    if (!prefN) return null;
    for (var len = trimmed.length - 1; len >= 1; len--) {
      var shorter = trimmed.slice(0, len);
      var ck = suggestCacheKey(shorter);
      var cached = suggestCache[ck];
      if (!cached || !cached.length) continue;
      var filtered = cached.filter(function (entry) {
        var nk = normalizeJa(entry.label);
        var head = normalizeJa(String(entry.label || '').trim().split(/[\s　]+/)[0] || '');
        return (nk && nk.indexOf(prefN) === 0) || (head && head.indexOf(prefN) === 0);
      });
      // Paint even 1+ matches so the panel is never empty while waiting on network
      if (filtered.length >= 1) {
        return applyLocalSuggestRank(filtered.slice(), raw).slice(0, lim);
      }
    }
    return null;
  }

  function mergeSuggestEntries(a, b) {
    var out = [];
    var seen = {};
    function push(list) {
      (list || []).forEach(function (entry) {
        if (!entry || !entry.label) return;
        var nk = normalizeJa(entry.label);
        if (!nk || seen[nk]) return;
        seen[nk] = true;
        out.push(entry);
      });
    }
    push(a);
    push(b);
    return out;
  }

  function prefixLenForStats(raw) {
    var t = String(raw || '').trim();
    if (!t) return 0;
    var n = normalizeJa(t);
    if (!n) return 0;
    return Math.min(n.length, 8);
  }

  function postSuggestStats(raw, latencyMs, itemCount) {
    var base = supaBase();
    if (!base) return;
    var plen = prefixLenForStats(raw);
    var empty = !(itemCount > 0);
    // Sample ~35% to keep write volume low
    if (Math.random() > 0.35 && !empty) return;
    fetch(base + '/rest/v1/rpc/record_suggest_stats', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        p_prefix_len: plen,
        p_latency_ms: Math.max(0, Math.round(latencyMs || 0)),
        p_empty: empty,
        p_item_count: Math.max(0, itemCount | 0)
      }),
      keepalive: true,
      mode: 'cors'
    }).catch(function () {});
  }

  function fetchSuggestEntriesQuiet(raw, limit) {
    var base = supaBase();
    if (!base) return Promise.resolve([]);
    var cacheKey = suggestCacheKey(raw);
    if (suggestCache[cacheKey]) {
      return Promise.resolve(suggestCache[cacheKey]);
    }
    var lim = Math.min(Math.max(limit || KEYWORD_SUGGEST_LIMIT, 8), 15);
    return fetch(base + '/rest/v1/rpc/suggest_search', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        raw_input: String(raw || ''),
        result_limit: lim
      }),
      mode: 'cors'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('suggest');
        return res.json();
      })
      .then(function (data) {
        var entries = parseSuggestItems(data, raw);
        suggestCache[cacheKey] = entries;
        return entries;
      })
      .catch(function () {
        return [];
      });
  }

  function pumpSuggestWarmQueue() {
    if (!suggestWarmQueue.length) return;
    var next = suggestWarmQueue.shift();
    fetchSuggestEntriesQuiet(next, KEYWORD_SUGGEST_LIMIT).then(function () {
      if (suggestWarmQueue.length) {
        setTimeout(pumpSuggestWarmQueue, 120);
      }
    });
  }

  function warmSuggestCache() {
    if (suggestWarmStarted) return;
    suggestWarmStarted = true;
    var base = supaBase();
    var startWarm = function (prefixes) {
      var list = (prefixes || []).filter(function (p) {
        return p && String(p).trim().length >= 1;
      });
      if (!list.length) list = FALLBACK_WARM_PREFIXES.slice();
      suggestWarmQueue = list.slice(0, 16).filter(function (p) {
        return !suggestCache[suggestCacheKey(p)];
      });
      if (suggestWarmQueue.length) pumpSuggestWarmQueue();
    };

    if (!base) {
      startWarm(FALLBACK_WARM_PREFIXES);
      return;
    }

    fetch(base + '/rest/v1/rpc/suggest_warm_prefixes', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({ p_limit: 16 }),
      mode: 'cors'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('warm');
        return res.json();
      })
      .then(function (data) {
        startWarm(Array.isArray(data) ? data : FALLBACK_WARM_PREFIXES);
      })
      .catch(function () {
        startWarm(FALLBACK_WARM_PREFIXES);
      });
  }

  function fetchSuggestEntries(raw, limit) {
    var base = supaBase();
    if (!base) return Promise.resolve([]);

    var cacheKey = suggestCacheKey(raw);
    if (suggestCache[cacheKey]) {
      return Promise.resolve(applyLocalSuggestRank(suggestCache[cacheKey].slice(), raw));
    }

    if (suggestAbort) {
      try {
        suggestAbort.abort();
      } catch (e) {}
    }
    suggestAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var lim = Math.min(Math.max(limit || KEYWORD_SUGGEST_LIMIT, 8), 15);
    var startedAt = typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now();

    return fetch(base + '/rest/v1/rpc/suggest_search', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        raw_input: String(raw || ''),
        result_limit: lim
      }),
      mode: 'cors',
      signal: suggestAbort ? suggestAbort.signal : undefined
    })
      .then(function (res) {
        if (!res.ok) throw new Error('suggest');
        return res.json();
      })
      .then(function (data) {
        var entries = parseSuggestItems(data, raw);
        suggestCache[cacheKey] = entries;
        persistSuggestCacheToSession();
        var elapsed =
          (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now()) - startedAt;
        postSuggestStats(raw, elapsed, entries.length);
        // Suggest-empty is NOT a SERP miss — only /search empty records miss
        return applyLocalSuggestRank(entries.slice(), raw).slice(0, lim);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') {
          // Keep warm provisional path: return cached/provisional instead of hard empty
          var kept = provisionalSuggestFromCache(raw, lim);
          return kept && kept.length ? kept : [];
        }
        var elapsed =
          (typeof performance !== 'undefined' && performance.now ? performance.now() : Date.now()) - startedAt;
        postSuggestStats(raw, elapsed, 0);
        var fallback = provisionalSuggestFromCache(raw, lim);
        return fallback && fallback.length ? fallback : [];
      });
  }

  function shortProductTitle(title) {
    var t = String(title || '').trim();
    if (!t) return '';
    t = t.replace(/[☆★].*$/g, '');
    t = t.replace(
      /(国内正規品|中古|未開封|開封済|送料込|送料無料|フィギュアショップ|破壊王子|【[^】]*】)/g,
      ''
    );
    t = t.replace(/[\s　]+/g, ' ').trim();
    if (t.length > 36) t = t.slice(0, 36) + '…';
    return t;
  }

  function fetchProductSuggestEntries(raw, limit) {
    var base = supaBase();
    var trimmed = String(raw || '').trim();
    if (!base || trimmed.length < 1) return Promise.resolve([]);

    return fetch(base + '/rest/v1/rpc/suggest_products', {
      method: 'POST',
      headers: apiHeaders(),
      body: JSON.stringify({
        raw_input: trimmed,
        result_limit: limit || PRODUCT_SUGGEST_LIMIT
      }),
      mode: 'cors'
    })
      .then(function (res) {
        if (!res.ok) throw new Error('suggest_products');
        return res.json();
      })
      .then(function (data) {
        var items = (data && data.items) || [];
        return items
          .map(function (row) {
            var full = String(row.full_title || row.title || '').trim();
            var title = shortProductTitle(String(row.title || full));
            return {
              id: row.id,
              title: title,
              fullTitle: full,
              url: String(row.url || '/products/' + (row.handle || '')),
              image: row.image || '',
              vendor: String(row.vendor || '').trim()
            };
          })
          .filter(function (row) {
            return row.title.length > 0;
          });
      })
      .catch(function () {
        return [];
      });
  }

  function fetchSuggestDebounced(raw, limit) {
    var seq = ++suggestSeq;
    var lim = limit || KEYWORD_SUGGEST_LIMIT;
    var cacheKey = suggestCacheKey(raw);
    var hasProvisional = !!(provisionalSuggestFromCache(raw, lim) || (suggestCache[cacheKey] && suggestCache[cacheKey].length));
    var waitMs = hasProvisional ? SUGGEST_DEBOUNCE_PROVISIONAL_MS : SUGGEST_DEBOUNCE_MS;
    // Exact cache: skip debounce for instant paint; still refresh cache in background
    if (suggestCache[cacheKey] && suggestCache[cacheKey].length) {
      clearTimeout(suggestTimer);
      suggestTimer = setTimeout(function () {
        fetchSuggestEntries(raw, lim);
      }, waitMs);
      return Promise.resolve({
        keywords: applyLocalSuggestRank(suggestCache[cacheKey].slice(), raw),
        products: []
      });
    }
    return new Promise(function (resolve) {
      clearTimeout(suggestTimer);
      suggestTimer = setTimeout(function () {
        // Keywords only (work / character / brand). No product thumbnails in suggest.
        fetchSuggestEntries(raw, lim).then(function (keywords) {
          resolve(
            seq === suggestSeq ? { keywords: keywords, products: [] } : { keywords: [], products: [] }
          );
        });
      }, waitMs);
    });
  }

  function getRawFromInstance(ps) {
    if (ps && typeof ps.__shopGetRaw === 'function') return ps.__shopGetRaw();
    return ps && ps.input ? ps.input.value : '';
  }

  function queryIconSvg() {
    return '<svg viewBox="0 0 18 19" width="18" height="18" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M11.03 11.68A5.784 5.784 0 1 1 2.85 3.5a5.784 5.784 0 0 1 8.18 8.18m.26 1.12a6.78 6.78 0 1 1 .72-.7l5.4 5.4a.5.5 0 1 1-.71.7z" clip-rule="evenodd"/></svg>';
  }

  function buildKeywordMarkup(term, matches) {
    var keywordMatches = (matches || []).filter(function (entry) {
      return entry && entry.label && isShortKeywordLabel(entry.label);
    });
    var trimmedTerm = String(term || '').trim();
    var totalCount = keywordMatches.length;
    var html = '';
    html += '<div id="predictive-search-results" role="listbox" class="shop-search-suggest">';
    /* Scroll pane: ~7 rows visible, rest via scrollbar */
    html += '<div class="shop-search-suggest__scroll">';
    html += '<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">';
    html += '<div class="predictive-search__result-group">';
    html +=
      '<ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-label="検索候補">';

    keywordMatches.forEach(function (entry, index) {
      var href = entry.url || searchUrlFor(entry.label);
      html +=
        '<li id="predictive-search-option-query-' +
        (index + 1) +
        '" class="predictive-search__list-item" role="option" aria-selected="false">';
      html +=
        '<a href="' +
        escapeHtml(href) +
        '" class="predictive-search__item predictive-search__item--query link link--text" tabindex="-1">';
      html += '<span class="predictive-search__query-icon" aria-hidden="true">' + queryIconSvg() + '</span>';
      html += '<div class="predictive-search__item-content predictive-search__item-content--centered">';
      html +=
        '<p class="predictive-search__item-heading h5" title="' +
        escapeHtml(entry.label) +
        '">' +
        escapeHtml(entry.label) +
        '</p>';
      html += '</div>';
      html += '<span class="predictive-search__query-chevron" aria-hidden="true">›</span>';
      html += '</a></li>';
    });

    html += '</ul></div></div></div>';

    if (trimmedTerm) {
      html += '<div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">';
    html +=
        '<button id="predictive-search-option-search-for" class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" type="submit" role="option" aria-selected="false" data-search-submit-term="' +
        escapeHtml(trimmedTerm) +
        '">';
      html += '<span data-predictive-search-search-for-text>「' + escapeHtml(trimmedTerm) + '」で検索</span>';
      html += '</button></div>';
    }

    try {
      var impressionLabels = keywordMatches.map(function (e) {
        return e.label;
      });
      if (impressionLabels.length) postSuggestImpressions(impressionLabels);
    } catch (e) {}

    html +=
      '<span class="predictive-search-status visually-hidden" role="status" aria-hidden="true"><span data-predictive-search-live-region-count-value data-total-results="' +
      totalCount +
      '">' +
      (totalCount ? '検索候補' : '「' + escapeHtml(trimmedTerm) + '」で検索') +
      '</span></span>';
    html += '</div>';
    return html;
  }

  function buildEmptyFocusMarkup(history) {
    var hist = (history || []).filter(function (label) {
      return isShortKeywordLabel(label);
    });

    var html = '';
    html += '<div id="predictive-search-results" role="listbox" class="shop-search-suggest shop-search-empty-focus">';

    html += '<div class="shop-search-history">';
    html += '<div class="shop-search-history__header">';
    html += '<span class="shop-search-history__title">検索履歴</span>';
    if (hist.length) {
    html +=
        '<button type="button" class="shop-search-history__clear" data-search-history-clear tabindex="-1">クリア</button>';
    }
    html += '</div>';
    if (!hist.length) {
      html += '<p class="shop-search-history__empty">検索履歴はありません</p>';
    } else {
      html += '<div class="shop-search-history__scroll">';
      html +=
        '<ul class="shop-search-history__list predictive-search__results-list list-unstyled" role="group" aria-label="検索履歴">';
      hist.forEach(function (label, index) {
        html += historyRowHtml(label, index);
      });
      html += '</ul></div>';
    }
    html += '</div>';

    html +=
      '<span class="predictive-search-status visually-hidden" role="status" aria-hidden="true"><span data-predictive-search-live-region-count-value data-total-results="' +
      hist.length +
      '">検索履歴</span></span>';
    html += '</div>';
    return html;
  }

  function buildHistoryMarkup(history) {
    var items = (history || []).filter(function (label) {
      return isShortKeywordLabel(label);
    });
    var html = '';
    html += '<div id="predictive-search-results" role="listbox" class="shop-search-suggest shop-search-history">';
    html += '<div class="shop-search-history__header">';
    html += '<span class="shop-search-history__title">検索履歴</span>';
    if (items.length) {
      html +=
        '<button type="button" class="shop-search-history__clear" data-search-history-clear tabindex="-1">クリア</button>';
    }
    html += '</div>';

    if (!items.length) {
      html += '<p class="shop-search-history__empty">検索履歴はありません</p>';
    } else {
      html += '<div class="shop-search-history__scroll">';
      html += '<ul class="shop-search-history__list predictive-search__results-list list-unstyled" role="group" aria-label="検索履歴">';
      items.forEach(function (label, index) {
        html += historyRowHtml(label, index);
      });
      html += '</ul></div>';
    }

    html +=
      '<span class="predictive-search-status visually-hidden" role="status" aria-hidden="true"><span data-predictive-search-live-region-count-value data-total-results="' +
      items.length +
      '">検索履歴</span></span>';
    html += '</div>';
    return html;
  }

  function getSuggestNavItems(ps) {
    if (!ps) return [];
    var nodes = ps.querySelectorAll(
      '#predictive-search-results-queries-list > li[role="option"], .shop-search-history__list > li[role="option"], .shop-search-popular__list > li[role="option"], button.predictive-search__item--term[role="option"]'
    );
    var seen = {};
    var list = [];
    Array.prototype.forEach.call(nodes, function (el) {
      var key = el.id || String(list.length) + ':' + (el.textContent || '').slice(0, 40);
      if (seen[key]) return;
        seen[key] = true;
      list.push(el);
    });
    return list;
  }

  function findOpenPredictiveSearch() {
    var all = document.querySelectorAll('predictive-search');
    var i;
    for (i = 0; i < all.length; i++) {
      if (all[i].getAttribute('open') || all[i].getAttribute('loading')) {
        if (getSuggestNavItems(all[i]).length) return all[i];
      }
    }
    for (i = 0; i < all.length; i++) {
      if (getSuggestNavItems(all[i]).length) return all[i];
    }
    var active = document.activeElement;
    if (!active || !active.closest) return null;
    var root = active.closest('.header-shop-search, predictive-search');
    if (!root) return null;
    if (root.tagName && root.tagName.toLowerCase() === 'predictive-search') return root;
    return root.querySelector('predictive-search');
  }

  function findActivePredictiveSearch() {
    var active = document.activeElement;
    if (active && active.closest) {
      var focused = active.closest('predictive-search');
      if (focused) return focused;
      var wrap = active.closest('.header-shop-search');
      if (wrap) {
        var nested = wrap.tagName && wrap.tagName.toLowerCase() === 'predictive-search'
          ? wrap
          : wrap.querySelector('predictive-search');
        if (nested) return nested;
        if (wrap.closest) {
          var parentPs = wrap.closest('predictive-search');
          if (parentPs) return parentPs;
        }
      }
    }
    return findOpenPredictiveSearch();
  }

  function getTypedQueryForSubmit(ps) {
    if (!ps) return '';
    if (ps.__shopGetQueryForSubmit) return String(ps.__shopGetQueryForSubmit() || '').trim();
    if (typeof ps.getQuery === 'function') return String(ps.getQuery() || '').trim();
    var input = getSearchInput(ps);
    return input ? String(input.value || '').trim() : '';
  }

  function submitTypedSearch(ps) {
    var q = getTypedQueryForSubmit(ps);
    if (!q) return false;
    if (ps.__shopSearchSubmit) {
      ps.__shopSearchSubmit(q, 'typed');
    } else {
      window.location.assign(searchUrlFor(q));
    }
        return true;
  }

  function getSearchInput(ps) {
    if (!ps) return null;
    return ps.querySelector('.header-shop-search__input') || ps.input || null;
  }

  function focusSearchInput(ps) {
    var input = getSearchInput(ps);
    if (!input) return;
    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      input.focus();
    }
  }

  function ensureSuggestPanelOpen(ps) {
    if (!ps) return false;
    if (ps.getAttribute('open')) return true;
    if (getSuggestNavItems(ps).length) {
      if (ps.open) ps.open();
      return !!ps.getAttribute('open');
    }
    if (ps.getAttribute('results') && ps.predictiveSearchResults && ps.predictiveSearchResults.innerHTML) {
      if (ps.open) ps.open();
      return !!ps.getAttribute('open');
    }
    if (isSearchEmpty(ps)) {
      if (ps.showSearchHistory) ps.showSearchHistory();
      return !!ps.getAttribute('open');
    }
    if (ps.onChange) ps.onChange();
    return !!ps.getAttribute('open');
  }

  function setSuggestInputActive(ps, active) {
    if (!ps) return;
    var field = ps.querySelector('.header-shop-search__field');
    if (!field) return;
    if (active) {
      field.classList.remove('header-shop-search__field--suggest-input-active');
      void field.offsetWidth;
      field.classList.add('header-shop-search__field--suggest-input-active');
    } else {
      field.classList.remove('header-shop-search__field--suggest-input-active');
    }
  }

  function clearSuggestSelection(ps, options) {
    if (!ps) return;
    options = options || {};
    var refocus = options.refocus !== false;
    var activate = options.activate !== false;
    var items = getSuggestNavItems(ps);
    items.forEach(function (el) {
      el.setAttribute('aria-selected', 'false');
    });
    var input = getSearchInput(ps);
    if (input) {
      input.removeAttribute('aria-activedescendant');
      if (refocus) focusSearchInput(ps);
    }
    setSuggestInputActive(ps, activate);
  }

  function switchSuggestSelection(ps, direction) {
    if (!ps) return;
    ensureSuggestPanelOpen(ps);

    var moveUp = direction === 'up';
    var items = getSuggestNavItems(ps);
    if (!items.length) return;

    var selected = ps.querySelector('li[aria-selected="true"], button[aria-selected="true"]');
    var selectedIndex = selected ? items.indexOf(selected) : -1;
    var nextIndex = 0;

    // Already on search bar (no selection): ↑ → last item, ↓ → first item
    if (selectedIndex < 0) {
      if (moveUp) {
        nextIndex = items.length - 1;
      } else {
        nextIndex = 0;
      }
      items.forEach(function (el) {
        el.setAttribute('aria-selected', 'false');
      });
      items[nextIndex].setAttribute('aria-selected', 'true');
      setSuggestInputActive(ps, false);
      var inputFromBar = getSearchInput(ps);
      if (inputFromBar) inputFromBar.setAttribute('aria-activedescendant', items[nextIndex].id || '');
      focusSearchInput(ps);
      try {
        items[nextIndex].scrollIntoView({ block: 'nearest' });
      } catch (e) {}
      return;
    }

    // First suggestion + ↑ → back to search bar
    if (moveUp && selectedIndex === 0) {
      clearSuggestSelection(ps);
      return;
    }

    // Last suggestion + ↓ → back to search bar
    if (!moveUp && selectedIndex >= items.length - 1) {
      clearSuggestSelection(ps);
      return;
    }

    if (moveUp) {
      nextIndex = selectedIndex - 1;
    } else {
      nextIndex = selectedIndex + 1;
    }

    if (nextIndex === selectedIndex) return;

    items.forEach(function (el) {
      el.setAttribute('aria-selected', 'false');
    });
    items[nextIndex].setAttribute('aria-selected', 'true');
    setSuggestInputActive(ps, false);

    var input = getSearchInput(ps);
    if (input) input.setAttribute('aria-activedescendant', items[nextIndex].id || '');
    focusSearchInput(ps);
    try {
      items[nextIndex].scrollIntoView({ block: 'nearest' });
    } catch (e) {}
  }

  function getSelectedSuggestLabel(ps) {
    if (!ps) return '';
    var selected = ps.querySelector('li[aria-selected="true"], button[aria-selected="true"]');
    if (!selected) return '';
    if (selected.matches && selected.matches('button.predictive-search__item--term')) {
      return String(selected.getAttribute('data-search-submit-term') || '').trim();
    }
    var link = selected.tagName === 'A' ? selected : selected.querySelector('a');
    if (link && link.classList.contains('predictive-search__item--suggest')) {
      var productTitle =
        link.getAttribute('data-product-title') ||
        ((link.querySelector('.predictive-search__item-heading') || {}).textContent || '');
      return {
        type: 'product',
        title: String(productTitle).trim(),
        url: link.getAttribute('href') || ''
      };
    }
    var heading = selected.querySelector('.predictive-search__item-heading');
    return heading ? String(heading.textContent || '').trim() : '';
  }

  function getLabelFromSuggestOption(option) {
    if (!option) return '';
    if (option.matches && option.matches('button.predictive-search__item--term')) {
      return String(option.getAttribute('data-search-submit-term') || '').trim();
    }
    var heading = option.querySelector('.predictive-search__item-heading');
    return heading ? String(heading.textContent || '').trim() : '';
  }

  // Keyboard selection OR mouse hover (blue row without aria-selected)
  function getEnterSuggestLabel(ps) {
    if (!ps) return '';
    var picked = getSelectedSuggestLabel(ps);
    if (picked) return picked;
    var hovered = ps.querySelector(
      '#predictive-search-results-queries-list > li:hover, .shop-search-history__list > li:hover, button.predictive-search__item--term:hover'
    );
    if (hovered) return getLabelFromSuggestOption(hovered);
    // Fallback: keep last mouse-hovered option for Enter timing gaps
    if (ps.__shopHoveredSuggestLabel) return String(ps.__shopHoveredSuggestLabel).trim();
    // Last fallback: if suggest panel is open, Enter uses first visible candidate
    var first = ps.querySelector(
      '#predictive-search-results-queries-list > li[role="option"], .shop-search-history__list > li[role="option"], button.predictive-search__item--term[role="option"]'
    );
    return getLabelFromSuggestOption(first);
  }

  function activateSelectedSuggest(ps) {
    if (!ps) return false;
    var picked = getEnterSuggestLabel(ps);
    if (!picked) return false;

    if (typeof picked === 'object' && picked.type === 'product') {
      if (picked.title) postSearchRecord(picked.title, 'product');
      window.location.assign(picked.url || searchUrlFor(picked.title));
      return true;
    }

    var label = String(picked || '').trim();
    if (!label) return false;

    if (ps.__shopSearchSubmit) {
      var selectedLi = ps.querySelector(
        'li[aria-selected="true"], #predictive-search-results-queries-list > li:hover, .shop-search-history__list > li:hover'
      );
      var source = ps.__shopHoveredSuggestSource || (
        selectedLi && selectedLi.closest('.shop-search-history') ? 'history' : 'suggest'
      );
      ps.__shopSearchSubmit(label, source);
      return true;
    }
    window.location.assign(searchUrlFor(label));
    return true;
  }

  var lastArrowAt = 0;
  var lastArrowDir = '';
  var lastSuggestEnterAt = 0;

  function isArrowKey(event) {
    var code = event.code || '';
    var key = event.key || '';
    var which = event.which || event.keyCode || 0;
    // During IME, browsers often fire a Process(229) event AND a real Arrow event.
    // Ignore bare 229 so we never move twice for one physical press.
    if (which === 229 && code !== 'ArrowUp' && code !== 'ArrowDown' && key !== 'ArrowUp' && key !== 'ArrowDown') {
      return '';
    }
    if (code === 'ArrowUp' || key === 'ArrowUp' || key === 'Up' || which === 38) return 'up';
    if (code === 'ArrowDown' || key === 'ArrowDown' || key === 'Down' || which === 40) return 'down';
    return '';
  }

  function isEnterKey(event) {
    var code = event.code || '';
    var key = event.key || '';
    var which = event.which || event.keyCode || 0;
    // Prefer code/key — during JP IME, which is often 229 for Backspace too
    if (code === 'Enter' || key === 'Enter') return true;
    if (code || key) return false;
    return which === 13;
  }

  function isBackspaceKey(event) {
    var code = event.code || '';
    var key = event.key || '';
    var which = event.which || event.keyCode || 0;
    if (code === 'Backspace' || key === 'Backspace') return true;
    if (code || key) return false;
    return which === 8;
  }

  function isImeProcessKey(event) {
    return !!(event.isComposing || event.keyCode === 229 || event.which === 229);
  }

  function consumeArrowEvent(event) {
    event.__shopSuggestArrowHandled = true;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function handleSuggestEscape(event) {
    if (event.key !== 'Escape' && event.code !== 'Escape') return false;
    var ps = findActivePredictiveSearch();
    if (!ps) return false;

    event.__shopSuggestArrowHandled = true;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (event.type !== 'keydown') return true;

    // 1st Esc: clear keyboard selection → search bar
    if (getSelectedSuggestLabel(ps)) {
      clearSuggestSelection(ps);
      return true;
    }
    // 2nd Esc: close panel, keep typed query
    if (ps.getAttribute('open') && typeof ps.close === 'function') {
      setSuggestInputActive(ps, false);
      ps.close(false);
    }
    return true;
  }

  function handleSuggestBackspace(event) {
    if (!isBackspaceKey(event)) return false;
    var ps = findActivePredictiveSearch();
    if (!ps || !getSelectedSuggestLabel(ps)) return false;

    // Clear ↓↑ highlight so this key never triggers suggest-submit.
    // Do not preventDefault — allow normal character delete in the input.
    if (event.type === 'keydown') {
      clearSuggestSelection(ps);
      setSuggestInputActive(ps, false);
    }
    event.__shopSuggestArrowHandled = true;
    return true;
  }

  function handleSuggestArrowKey(event) {
    if (event.__shopSuggestArrowHandled) return true;

    if (handleSuggestEscape(event)) return true;
    if (handleSuggestBackspace(event)) return true;

    // Arrows first — JP IME often sends keydown with which=229 for ArrowUp/Down.
    // Must not fall into the Enter/IME branch or ↑↓ stop working.
    var dir = isArrowKey(event);
    if (dir) {
      var ps = findOpenPredictiveSearch();
      if (!ps) return false;
      if (!getSuggestNavItems(ps).length && !ps.getAttribute('open') && !ps.getAttribute('loading')) {
        return false;
      }

      if (event.type === 'keyup') {
        consumeArrowEvent(event);
        return true;
      }
      if (event.type !== 'keydown') return false;

      consumeArrowEvent(event);

      var now = Date.now();
      if (event.repeat) {
        if (now - lastArrowAt < 45) return true;
      } else if (now - lastArrowAt < 90 && lastArrowDir === dir) {
        return true;
      }

      lastArrowAt = now;
      lastArrowDir = dir;
      switchSuggestSelection(ps, dir);
      focusSearchInput(ps);
      return true;
    }

    // Enter only when code/key is Enter (never bare IME 229 — that is also Backspace)
    // JP IME: keydown may be 229 with code=Enter, then keyup code=Enter — both OK via isEnterKey.
    if (isEnterKey(event)) {
      var enterPs = findActivePredictiveSearch() || findOpenPredictiveSearch();
      if (!enterPs) return false;

      var selected = getEnterSuggestLabel(enterPs);
      var typed = getTypedQueryForSubmit(enterPs);

      // Highlighted / hovered suggestion: search on Enter
      if (selected) {
        event.__shopSuggestArrowHandled = true;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        if (event.type === 'keydown' || event.type === 'keyup') {
          if (Date.now() - lastSuggestEnterAt < 450) return true;
          lastSuggestEnterAt = Date.now();
          activateSelectedSuggest(enterPs);
        }
        return true;
      }

      // No selection: let IME finish conversion on composing Enter
      if (isImeProcessKey(event) && event.type === 'keydown') return false;
      if (!typed) return false;

      event.__shopSuggestArrowHandled = true;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (event.type === 'keydown' || event.type === 'keyup') {
        if (Date.now() - lastSuggestEnterAt < 450) return true;
        lastSuggestEnterAt = Date.now();
        submitTypedSearch(enterPs);
      }
      return true;
    }

    return false;
  }

  function installGlobalSuggestKeys() {
    if (window.__shopSuggestGlobalKeys) return;
    window.__shopSuggestGlobalKeys = true;

    window.addEventListener('keydown', handleSuggestArrowKey, true);
    window.addEventListener('keyup', handleSuggestArrowKey, true);
  }

  function silenceLegacyArrowHandlers(ps) {
    if (!ps || ps.__shopLegacyArrowSilenced) return;
    ps.__shopLegacyArrowSilenced = true;

    // Constructor already bound the original onKeyup/onKeydown. Capture-stop them.
    function blockLegacy(event) {
      if (isArrowKey(event)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      // Enter on a candidate: run search here too (fallback if window handler missed)
      if (isEnterKey(event) && getEnterSuggestLabel(ps)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (event.type === 'keydown') {
          if (Date.now() - lastSuggestEnterAt < 450) return;
          lastSuggestEnterAt = Date.now();
          activateSelectedSuggest(ps);
        }
      }
    }
    ps.addEventListener('keydown', blockLegacy, true);
    ps.addEventListener('keyup', blockLegacy, true);
  }

  function bindSuggestKeyboard(ps, input) {
    if (!ps) return;
    installGlobalSuggestKeys();
    silenceLegacyArrowHandlers(ps);

    input = input || getSearchInput(ps);
    if (input && !input.dataset.shopSuggestKeysReady) {
      input.dataset.shopSuggestKeysReady = '1';
    }
    if (input && !input.dataset.shopClearBlueReady) {
      input.dataset.shopClearBlueReady = '1';
      function clearBlueOnType() {
        setSuggestInputActive(ps, false);
      }
      input.addEventListener('input', clearBlueOnType);
      input.addEventListener('compositionupdate', clearBlueOnType);
      input.addEventListener('compositionend', clearBlueOnType);
    }

    var results = ps.querySelector('[data-predictive-search]');
    if (results && !results.dataset.shopKeepInputFocus) {
      results.dataset.shopKeepInputFocus = '1';
      results.addEventListener('mousedown', function (event) {
        if (event.target.closest('a, button')) {
          markTouchSuggestGuard();
          return;
        }
        event.preventDefault();
        focusSearchInput(ps);
      });
      results.addEventListener(
        'touchstart',
        function (event) {
          markTouchSuggestGuard();
          if (event.target.closest('a, button, li[role="option"]')) {
            markTouchSuggestGuard();
          }
        },
        { passive: true }
      );
      results.addEventListener(
        'pointerdown',
        function (event) {
          if (event.target.closest('a, button, li[role="option"], .predictive-search__item')) {
            markTouchSuggestGuard();
          }
        },
        true
      );
      // Mouse enter a row: clear keyboard selection so hover is the only highlight
      results.addEventListener('mousemove', function (event) {
        var row = event.target.closest('li[role="option"], button.predictive-search__item--term');
        if (!row) return;
        var hoveredLabel = getLabelFromSuggestOption(row);
        if (hoveredLabel) {
          ps.__shopHoveredSuggestLabel = hoveredLabel;
          ps.__shopHoveredSuggestSource =
            row.closest && row.closest('.shop-search-history') ? 'history' : 'suggest';
        }
        var selected = ps.querySelector('[aria-selected="true"]');
        if (!selected) return;
        if (selected === row || selected.contains(row)) return;
        selected.setAttribute('aria-selected', 'false');
        var inp = getSearchInput(ps);
        if (inp) inp.removeAttribute('aria-activedescendant');
        setSuggestInputActive(ps, false);
      });
      results.addEventListener('mouseleave', function () {
        ps.__shopHoveredSuggestLabel = '';
        ps.__shopHoveredSuggestSource = '';
      });
    }
  }

  function installChipSearch(ps) {
    installGlobalSuggestKeys();
    bindSuggestKeyboard(ps, ps.querySelector('.header-shop-search__input') || ps.input);

    var field = ps.querySelector('.header-shop-search__field');
    if (!field || field.dataset.chipsReady) return;
    field.dataset.chipsReady = '1';

    var typing = field.querySelector('.header-shop-search__input');
    var chipsEl = field.querySelector('[data-search-chips]');
    var clearAll = field.querySelector('[data-search-clear-all]');
    if (!typing || !chipsEl) return;

    bindSuggestKeyboard(ps, typing);

    var hidden = field.querySelector('[data-search-q]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'q';
      hidden.setAttribute('data-search-q', '');
      typing.parentNode.insertBefore(hidden, typing.nextSibling);
    }

    // Prefer URL ?q= over browser-restored typed leftovers
    var urlQ = '';
    try {
      urlQ = String(new URL(window.location.href).searchParams.get('q') || '').trim();
    } catch (e) {}
    var initial = urlQ || hidden.value || typing.value || '';
    typing.removeAttribute('name');
    if (urlQ) {
      typing.value = '';
      hidden.value = urlQ;
    }

    var chips = [];
    var editMode = false;

    function syncHidden() {
      var q = editMode ? typing.value.trim() : chips.join(' ');
      hidden.value = q;
      var has = q.length > 0;
      field.classList.toggle('header-shop-search__field--has-chips', !editMode && chips.length > 0);
      field.classList.toggle('header-shop-search__field--has-content', has);
      field.classList.toggle('header-shop-search__field--edit-mode', editMode);
      field.classList.toggle('header-shop-search__field--chip-mode', !editMode);
      if (clearAll) {
        var showClear = editMode && typing.value.trim().length > 0;
        if (showClear) clearAll.removeAttribute('hidden');
        else clearAll.setAttribute('hidden', '');
      }
      return hidden.value;
    }

    function getQueryForSubmit() {
      if (editMode) return typing.value.trim();
      var parts = chips.slice();
      var typed = typing.value.trim();
      if (typed) {
        var joined = parts.join(' ').trim();
        // Avoid "ナルト" chips + "ナルト" typing → "ナルト ナルト"
        if (!joined) {
          parts = splitTerms(typed);
        } else if (typed !== joined && joined.indexOf(typed) !== 0) {
          splitTerms(typed).forEach(function (term) {
            parts.push(term);
          });
        }
      }
      return parts.join(' ').trim();
    }

    function renderChips() {
      chipsEl.innerHTML = chips
        .map(function (term, i) {
          return (
            '<span class="header-shop-search__chip">' +
            '<span class="header-shop-search__chip-label">' +
            escapeHtml(term) +
            '</span>' +
            '<button type="button" class="header-shop-search__chip-remove" data-chip-index="' +
            i +
            '" aria-label="' +
            escapeHtml(term) +
            'を削除">×</button></span>'
          );
        })
        .join('');
      syncHidden();
    }

    function enterEditMode() {
      if (editMode) return;
      editMode = true;
      var merged = chips.join(' ');
      if (typing.value.trim()) {
        merged = merged ? merged + ' ' + typing.value.trim() : typing.value.trim();
      }
      typing.value = merged;
      chips = [];
      chipsEl.innerHTML = '';
      syncHidden();
      if (ps.onChange) ps.onChange();
    }

    function enterChipMode() {
      if (!editMode && chips.length) return;
      editMode = false;
      if (typing.value.trim()) {
        chips = splitTerms(typing.value);
      }
      typing.value = '';
      renderChips();
      syncHidden();
    }

    function hasContent() {
      return editMode ? typing.value.trim().length > 0 : chips.length > 0 || typing.value.trim().length > 0;
    }

    var composing = false;

    typing.addEventListener('compositionstart', function () {
      composing = true;
      ps.isComposing = true;
      // Do NOT clear outside-dismiss here — IME may still be finishing after outside tap
    });
    typing.addEventListener('compositionupdate', function () {
      composing = true;
      ps.isComposing = true;
      if (window.__shopSuggestNavigating && lockedPickQuery) {
        typing.value = lockedPickQuery;
        if (hidden) hidden.value = lockedPickQuery;
        return;
      }
      // Outside-dismissed: stay closed even if focus remained (IME Windows quirk)
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(ps);
        return;
      }
      if (typeof ps.onChange === 'function') ps.onChange();
    });
    typing.addEventListener('compositionend', function () {
      composing = false;
      ps.isComposing = false;
      // Suggest pick in progress: never let IME re-append leftover typed chars
      if (window.__shopSuggestNavigating && lockedPickQuery) {
        typing.value = lockedPickQuery;
        if (hidden) hidden.value = lockedPickQuery;
        reassertLockedPickQuery();
        return;
      }
      if (window.__shopSuggestNavigating) {
        typing.value = lockedPickQuery || '';
        if (hidden) hidden.value = lockedPickQuery || hidden.value || '';
        return;
      }
      // Outside tap → IME commit must keep suggest closed (Mercari)
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(ps);
        return;
      }
      if (document.activeElement === typing && typeof ps.onChange === 'function') {
        ps.onChange();
      }
    });

    function allowSuggestFromInputTap() {
      // Mercari: explicit tap on field re-enables suggest (bypasses outside lock)
      clearSuggestDismissed(true);
      try {
        ps.removeAttribute('data-shop-suggest-dismissed');
        if (ps.predictiveSearchResults) {
          ps.predictiveSearchResults.style.removeProperty('display');
        }
      } catch (e) {}
      // Empty field → history immediately (don't wait only on onChange)
      if (isSearchEmpty(ps) && typeof ps.showSearchHistory === 'function') {
        ps.showSearchHistory();
      } else if (typeof ps.onChange === 'function') {
        ps.onChange();
      }
      setTimeout(function () {
        if (suggestClosedByOutside) return;
        if (document.activeElement !== typing) return;
        if (ps.getAttribute('open')) return;
        clearSuggestDismissed(true);
        if (ps.predictiveSearchResults) ps.predictiveSearchResults.style.removeProperty('display');
        if (isSearchEmpty(ps) && typeof ps.showSearchHistory === 'function') {
          ps.showSearchHistory();
        } else if (typeof ps.onChange === 'function') {
          ps.onChange();
        }
      }, 50);
    }

    // Explicit tap on the field re-opens suggest (Mercari: 枠内タップで再表示)
    typing.addEventListener('pointerdown', allowSuggestFromInputTap, true);
    typing.addEventListener('mousedown', allowSuggestFromInputTap, true);
    typing.addEventListener('click', allowSuggestFromInputTap, true);
    field.addEventListener(
      'pointerdown',
      function (event) {
        if (event.target === typing || (event.target && event.target.closest && event.target.closest('.header-shop-search__input'))) {
          allowSuggestFromInputTap();
        }
      },
      true
    );

    function clearTypedInputHard() {
      composing = false;
      ps.isComposing = false;
      try {
        if (document.activeElement === typing) typing.blur();
      } catch (e) {}
      // Beat late IME commit: clear twice around a frame
      typing.value = '';
      try {
        typing.setAttribute('value', '');
      } catch (e2) {}
      requestAnimationFrame(function () {
        if (!window.__shopSuggestNavigating) return;
        typing.value = '';
      });
      setTimeout(function () {
        if (!window.__shopSuggestNavigating) return;
        typing.value = '';
      }, 0);
      setTimeout(function () {
        if (!window.__shopSuggestNavigating) return;
        typing.value = '';
      }, 50);
    }

    function applyQueryAndSearch(label, searchSource) {
      var q = normalizeSearchQuery(label);
      if (!q) return;
      var source = String(searchSource || 'typed');
      addSearchHistory(q);
      markTouchSuggestGuard();

      // Instant swap: typed leftovers must never flash after the picked label
      composing = false;
      ps.isComposing = false;
      chips = [];
      editMode = true;
      lockSearchInputsToQuery(q);
      hidden.value = q;
      syncHidden();
      reassertLockedPickQuery();
      requestAnimationFrame(reassertLockedPickQuery);
      setTimeout(reassertLockedPickQuery, 0);
      setTimeout(reassertLockedPickQuery, 16);
      setTimeout(reassertLockedPickQuery, 50);

      if (ps.close) ps.close(false);
      try {
        sessionStorage.setItem('figusen_learn_once_' + q.toLowerCase(), '1');
        sessionStorage.setItem('figusen_last_search_source', source);
      } catch (e) {}
      postSearchRecord(q, source);
      window.location.assign(searchUrlFor(q));
    }

    ps.__shopGetRaw = getRawForSuggest;
    ps.__shopSyncHidden = syncHidden;
    ps.__shopHasContent = hasContent;
    ps.__shopGetQueryForSubmit = getQueryForSubmit;
    ps.__shopSearchSubmit = applyQueryAndSearch;

    function getRawForSuggest() {
      if (editMode) return typing.value;
      if (!chips.length) return typing.value;
      if (!typing.value.trim()) return chips.join(' ') + ' ';
      return chips.join(' ') + ' ' + typing.value;
    }

    if (initial.trim()) {
      chips = splitTerms(initial);
      typing.value = '';
      editMode = false;
      renderChips();
    } else {
      syncHidden();
    }

    function reopenSuggestOnFocus() {
      // During outside-close lock, ignore focus (IME may refocus). Explicit tap uses allowSuggestFromInputTap.
      if (suggestClosedByOutside) return;
      clearSuggestDismissed();
      if (document.activeElement !== typing) return;
      if (typeof ps.onChange === 'function') {
        ps.onChange();
        return;
      }
      if (isSearchEmpty(ps) && typeof ps.showSearchHistory === 'function') {
        ps.showSearchHistory();
      }
    }

    typing.addEventListener('focus', function () {
      if (suggestClosedByOutside) return;
      clearSuggestDismissed();
      enterEditMode();
      requestAnimationFrame(reopenSuggestOnFocus);
      setTimeout(reopenSuggestOnFocus, 0);
    });

    typing.addEventListener('input', function () {
      // Late IME must not re-append typed leftovers after a suggest pick
      if (window.__shopSuggestNavigating && lockedPickQuery) {
        typing.value = lockedPickQuery;
        if (hidden) hidden.value = lockedPickQuery;
        return;
      }
      // New characters after outside dismiss → allow suggest (user is typing again)
      if (suggestClosedByOutside) clearSuggestDismissed(true);
      if (!editMode && typing.value.trim()) enterEditMode();
      syncHidden();
    });

    typing.addEventListener('keydown', function (event) {
      if (!suggestClosedByOutside) return;
      var k = event.key;
      if (k === 'Escape' || k === 'Tab' || k === 'Shift' || k === 'Control' || k === 'Alt' || k === 'Meta') return;
      // Real key after outside → reopen (not the IME commit from the outside tap itself)
      if (Date.now() < outsideCloseLockUntil) return;
      clearSuggestDismissed(true);
    });

    typing.addEventListener('blur', function (e) {
      var delay = isCoarsePointer() ? 280 : 120;
      setTimeout(function () {
        if (window.__shopSuggestNavigating) return;
        if (document.activeElement === typing || document.activeElement === ps.input) return;
        if (isInsideSuggestUi(document.activeElement) || isInsideSuggestUi(e.relatedTarget)) return;
        if (isTouchSuggestGuarded()) return;
        // Already closed by outside — keep closed without re-marking
        if (suggestClosedByOutside) {
          forceCloseSuggestPanel(ps);
          return;
        }
        markSuggestDismissed();
        forceCloseSuggestPanel(ps);
        enterChipMode();
      }, delay);
    });

    if (clearAll) {
      clearAll.addEventListener('mousedown', function (e) {
        e.preventDefault();
      });
      clearAll.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        chips = [];
        typing.value = '';
        hidden.value = '';
        editMode = false;
        renderChips();
        if (ps.close) ps.close(true);
        typing.focus();
      });
    }

    var submitBtn = field.querySelector('.header-shop-search__submit');
    if (submitBtn && !submitBtn.dataset.shopSubmitReady) {
      submitBtn.dataset.shopSubmitReady = '1';

      function runSearchFromSubmit() {
        var q = getQueryForSubmit();
        if (!q) return false;
        applyQueryAndSearch(q, 'typed');
        return true;
      }

      submitBtn.addEventListener(
        'mousedown',
        function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (!runSearchFromSubmit()) typing.focus();
        },
        true
      );
    }

    field.addEventListener('mousedown', function (e) {
      if (
        e.target.closest(
          '.header-shop-search__chip-remove, [data-search-clear-all], .header-shop-search__submit'
        )
      ) {
        return;
      }
      if (!editMode) {
        e.preventDefault();
        typing.focus();
      }
    });

    chipsEl.addEventListener('mousedown', function (e) {
      var btn = e.target.closest('.header-shop-search__chip-remove');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var idx = parseInt(btn.getAttribute('data-chip-index'), 10);
      if (isNaN(idx)) return;
      chips.splice(idx, 1);
      renderChips();
      if (!chips.length && !typing.value.trim()) {
        hidden.value = '';
        syncHidden();
        if (ps.close) ps.close(true);
      } else if (ps.onChange) {
        ps.onChange();
      }
    });

    var form = typing.form;
    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          e.preventDefault();
          if (activateSelectedSuggest(ps)) return;
          var q = getQueryForSubmit();
          if (q) {
            applyQueryAndSearch(q, 'typed');
            return;
          }
          if (editMode && typing.value.trim()) {
            chips = splitTerms(typing.value);
            typing.value = '';
            editMode = false;
            renderChips();
          }
          syncHidden();
        },
        true
      );
    }

    bindSuggestKeyboard(ps, typing);
  }

  function isInsideSuggestUi(target) {
    if (!target || !target.closest) return false;
    // Include panel/scroll chrome so mobile scroll/drag does not count as outside
    return !!target.closest(
      '.header-shop-search__field, .header-shop-search__input, .header-shop-search__chips, .header-shop-search__submit, .header-shop-search__clear-all, [data-search-chips], [data-search-history-clear], [data-search-history-remove], predictive-search, .predictive-search, .shop-search-suggest, .shop-search-suggest__scroll, .shop-search-history__scroll, .predictive-search__list-item, .predictive-search__item, .shop-search-history, .shop-search-empty-focus'
    );
  }

  function endImeAndBlurSearchInputs() {
    document.querySelectorAll('.header-shop-search__input, predictive-search input[type="search"]').forEach(function (input) {
      try {
        var ps = input.closest('predictive-search');
        if (ps) ps.isComposing = false;
        // Blur commits IME → underline goes away; typed text stays
        if (document.activeElement === input) input.blur();
      } catch (e) {}
    });
  }

  function closeAllOpenSuggests() {
    markSuggestDismissed();
    document.querySelectorAll('predictive-search').forEach(forceCloseSuggestPanel);
    endImeAndBlurSearchInputs();
    function recloseWhileDismissed() {
      if (!suggestClosedByOutside) return;
      document.querySelectorAll('predictive-search').forEach(forceCloseSuggestPanel);
    }
    requestAnimationFrame(recloseWhileDismissed);
    setTimeout(recloseWhileDismissed, 0);
    setTimeout(recloseWhileDismissed, 50);
    // Mobile IME often commits later than desktop
    setTimeout(recloseWhileDismissed, 200);
    setTimeout(recloseWhileDismissed, 450);
    if (isCoarsePointer()) setTimeout(recloseWhileDismissed, 800);
  }

  function installOutsideSuggestClose() {
    if (window.__shopSuggestOutsideClose) return;
    window.__shopSuggestOutsideClose = true;
    installSuggestDismissGuard();

    function onOutsidePointer(event) {
      if (isInsideSuggestUi(event.target)) {
        markTouchSuggestGuard();
        return;
      }
      var hasOpenSuggest = document.querySelector('predictive-search[open], predictive-search[loading]');
      var inputFocused =
        document.activeElement &&
        document.activeElement.closest &&
        document.activeElement.closest('.header-shop-search__input, predictive-search input');
      var panelVisible = false;
      try {
        document.querySelectorAll('.header-shop-search .predictive-search').forEach(function (el) {
          if (getComputedStyle(el).display !== 'none') panelVisible = true;
        });
      } catch (e2) {}
      if (!hasOpenSuggest && !panelVisible && !inputFocused && !suggestClosedByOutside) return;
      // Mercari: outside → close suggest (IME underline may clear; suggest must stay closed)
      closeAllOpenSuggests();
      try {
        document.querySelectorAll('.header-shop-search__field--suggest-input-active').forEach(function (field) {
          field.classList.remove('header-shop-search__field--suggest-input-active');
        });
      } catch (e) {}
    }

    document.addEventListener('pointerdown', onOutsidePointer, true);
    document.addEventListener('touchstart', onOutsidePointer, { capture: true, passive: true });
    document.addEventListener('mousedown', onOutsidePointer, true);
  }

  function installSearchLearning() {
    if (window.__shopSearchLearnInstalled) return;
    window.__shopSearchLearnInstalled = true;
    installOutsideSuggestClose();

    // Mercari-like: scroll/slide must NOT search. Only a firm tap (click / short press).
    var SUGGEST_TAP_MOVE_PX = 12;
    var suggestTapGesture = null;

    function suggestPickSelector() {
      return (
        '.header-shop-search a.predictive-search__item--query, #predictive-search-results-queries-list a.predictive-search__item--query, .shop-search-history a.predictive-search__item--query, .shop-search-popular a.predictive-search__item--query, [data-search-submit-term], [data-search-history-clear], [data-search-history-remove]'
      );
    }

    function eventPoint(event) {
      if (event.touches && event.touches[0]) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
      }
      if (event.changedTouches && event.changedTouches[0]) {
        return { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }
      if (typeof event.clientX === 'number' && typeof event.clientY === 'number') {
        return { x: event.clientX, y: event.clientY };
      }
      return null;
    }

    function isTouchLikeEvent(event) {
      if (event.pointerType === 'touch' || event.pointerType === 'pen') return true;
      if (event.type.indexOf('touch') === 0) return true;
      // Coarse pointer without pointerType (older WebViews)
      if (!event.pointerType && isCoarsePointer() && event.type !== 'mousedown' && event.type !== 'click') {
        return true;
      }
      return false;
    }

    function beginSuggestTapGesture(event) {
      var target = event.target.closest(suggestPickSelector());
      if (!target) {
        suggestTapGesture = null;
        return;
      }
      var pt = eventPoint(event);
      suggestTapGesture = {
        target: target,
        x: pt ? pt.x : 0,
        y: pt ? pt.y : 0,
        moved: false,
        touch: isTouchLikeEvent(event),
        at: Date.now()
      };
    }

    function updateSuggestTapGesture(event) {
      if (!suggestTapGesture) return;
      var pt = eventPoint(event);
      if (!pt) return;
      if (
        Math.abs(pt.x - suggestTapGesture.x) > SUGGEST_TAP_MOVE_PX ||
        Math.abs(pt.y - suggestTapGesture.y) > SUGGEST_TAP_MOVE_PX
      ) {
        suggestTapGesture.moved = true;
      }
    }

    function commitSuggestPick(event, labelOverride, sourceOverride) {
      if (Date.now() - lastSuggestPickAt < 400) return true;

      var removeBtn = event.target.closest('[data-search-history-remove]');
      if (removeBtn) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        lastSuggestPickAt = Date.now();
        var removeLabel = removeBtn.getAttribute('data-search-history-remove') || '';
        removeSearchHistoryItem(removeLabel);
        var psRemove = removeBtn.closest('predictive-search');
        if (psRemove && psRemove.showSearchHistory) psRemove.showSearchHistory();
        return true;
      }

      var clearBtn = event.target.closest('[data-search-history-clear]');
      if (clearBtn) {
        event.preventDefault();
        event.stopPropagation();
        lastSuggestPickAt = Date.now();
        clearSearchHistory();
        var psClear = clearBtn.closest('predictive-search');
        if (psClear && psClear.showSearchHistory) psClear.showSearchHistory();
        return true;
      }

      var submitBtn = event.target.closest('[data-search-submit-term]');
      if (submitBtn) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        markTouchSuggestGuard();
        lastSuggestPickAt = Date.now();
        var psSubmit = submitBtn.closest('predictive-search');
        var term = submitBtn.getAttribute('data-search-submit-term') || '';
        if (term) lockSearchInputsToQuery(term);
        if (psSubmit && psSubmit.__shopSearchSubmit && term) {
          psSubmit.__shopSearchSubmit(term, 'typed');
        }
        return true;
      }

      var link = event.target.closest(
        '.header-shop-search a.predictive-search__item--query, #predictive-search-results-queries-list a.predictive-search__item--query, .shop-search-history a.predictive-search__item--query, .shop-search-popular a.predictive-search__item--query'
      );
      if (!link) return false;
      var ps = link.closest('predictive-search');
      var heading = link.querySelector('.predictive-search__item-heading');
      var pickedLabel =
        labelOverride || (heading ? String(heading.textContent || '').trim() : '');
      if (ps && ps.__shopSearchSubmit && pickedLabel) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        markTouchSuggestGuard();
        lastSuggestPickAt = Date.now();
        lockSearchInputsToQuery(pickedLabel);
        var pickSource =
          sourceOverride ||
          (link.closest('.shop-search-history') ? 'history' : 'suggest');
        ps.__shopSearchSubmit(pickedLabel, pickSource);
        return true;
      }
      return false;
    }

    document.addEventListener(
      'pointerdown',
      function (event) {
        beginSuggestTapGesture(event);
        // Desktop mouse only: pick early so IME leftovers cannot flash.
        // Touch must wait for a real tap (click / short press without move).
        if (!suggestTapGesture || suggestTapGesture.touch) return;
        if (event.pointerType && event.pointerType !== 'mouse') return;
        commitSuggestPick(event);
      },
      true
    );

    document.addEventListener(
      'touchstart',
      function (event) {
        beginSuggestTapGesture(event);
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'pointermove',
      function (event) {
        updateSuggestTapGesture(event);
      },
      true
    );

    document.addEventListener(
      'touchmove',
      function (event) {
        updateSuggestTapGesture(event);
      },
      { capture: true, passive: true }
    );

    document.addEventListener(
      'mousedown',
      function (event) {
        // Mouse fallback when PointerEvent is unavailable
        if (window.PointerEvent) return;
        beginSuggestTapGesture(event);
        if (suggestTapGesture && !suggestTapGesture.touch) commitSuggestPick(event);
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest(
          'a.predictive-search__item--query, button.predictive-search__item--term, [data-search-submit-term], [data-search-history-clear], [data-search-history-remove]'
        );
        if (!link) {
          suggestTapGesture = null;
          return;
        }

        // Scroll / slide: browsers may still emit click in some WebViews — block if moved
        if (suggestTapGesture && suggestTapGesture.moved) {
          event.preventDefault();
          event.stopPropagation();
          suggestTapGesture = null;
          return;
        }

        // Already committed from mouse pointerdown
        if (Date.now() - lastSuggestPickAt < 400 || window.__shopSuggestNavigating) {
          event.preventDefault();
          event.stopPropagation();
          reassertLockedPickQuery();
          suggestTapGesture = null;
          return;
        }

        // Touch / pen: firm tap only (click after no meaningful move)
        commitSuggestPick(event);
        suggestTapGesture = null;
      },
      true
    );

    // Do NOT pick on touchend — finger-up after scroll would false-trigger search

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.getAttribute('role') !== 'search') return;
        var ps = form.closest('predictive-search');
        if (ps && ps.__shopSyncHidden) ps.__shopSyncHidden();
        var input = form.querySelector('[data-search-q], input[name="q"]');
        if (input && input.value.trim()) postSearchRecord(input.value, 'typed');
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var productLink = event.target.closest(
          '.card__heading a, .card-wrapper .full-unstyled-link, .product-card-wrapper a, .predictive-search__item--suggest[data-product-title]'
        );
        if (productLink) {
          var productTitle =
            productLink.getAttribute('data-product-title') ||
            (productLink.querySelector('.predictive-search__item-heading') || productLink).textContent ||
            '';
          productTitle = String(productTitle).trim();
          if (productTitle.length >= 2) postSearchRecord(productTitle, 'product');
        }
      },
      true
    );

    try {
      if (window.location.pathname.indexOf('/search') !== -1) {
        var params = new URLSearchParams(window.location.search);
        var landedQ = params.get('q');
        if (landedQ) {
          addSearchHistory(landedQ);
          var isEmpty = document.querySelector('.template-search--empty');
          var missKey = 'figusen_miss_once_' + landedQ.toLowerCase();
          if (isEmpty && !sessionStorage.getItem(missKey)) {
            sessionStorage.setItem(missKey, '1');
            postSearchMiss(landedQ);
          }
          var onceKey = 'figusen_learn_once_' + landedQ.toLowerCase();
          if (!sessionStorage.getItem(onceKey)) {
            sessionStorage.setItem(onceKey, '1');
            if (!isEmpty) postSearchRecord(landedQ, 'typed');
          }
        }
      }

      scheduleVisibleTitleIngest();
      if (window.MutationObserver) {
        var observer = new MutationObserver(scheduleVisibleTitleIngest);
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        window.addEventListener('load', scheduleVisibleTitleIngest);
      }
    } catch (e) {}
  }

  function patchPredictiveSearch() {
    var SearchFormCtor = window.customElements && customElements.get('search-form');
    if (SearchFormCtor && SearchFormCtor.prototype && !SearchFormCtor.prototype.__shopResetSafe) {
      SearchFormCtor.prototype.__shopResetSafe = true;
      SearchFormCtor.prototype.toggleResetButton = function () {
        if (!this.resetButton) return;
        var hidden = this.resetButton.classList.contains('hidden');
        if (this.input && this.input.value.length > 0 && hidden) this.resetButton.classList.remove('hidden');
        else if (this.input && this.input.value.length === 0 && !hidden) this.resetButton.classList.add('hidden');
      };
    }

    var Ctor = window.customElements && customElements.get('predictive-search');
    if (!Ctor || !Ctor.prototype || Ctor.prototype.__shopJaSuggestPatched) return !!Ctor;
    Ctor.prototype.__shopJaSuggestPatched = true;

    Ctor.prototype.onFormSubmit = function (event) {
      if (this.__shopSyncHidden) this.__shopSyncHidden();
      var q = '';
      if (this.__shopHasContent && this.__shopHasContent()) {
        var hiddenQ = this.querySelector('[data-search-q]');
        q = hiddenQ ? hiddenQ.value.trim() : this.input.value.trim();
      } else {
        q = this.getQuery();
      }
      if (!q || this.querySelector('[aria-selected="true"] a')) {
        event.preventDefault();
      }
    };

    Ctor.prototype.toggleResetButton = SearchFormCtor.prototype.toggleResetButton;

    Ctor.prototype.switchOption = function (direction) {
      switchSuggestSelection(this, direction);
    };

    var origRender = Ctor.prototype.renderSearchResults;
    Ctor.prototype.renderSearchResults = function (resultsMarkup) {
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(this);
        return;
      }
      origRender.call(this, resultsMarkup);
      bindSuggestKeyboard(this, getSearchInput(this));
      if (!isCoarsePointer()) focusSearchInput(this);
    };

    var origOpen = Ctor.prototype.open;
    Ctor.prototype.open = function () {
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(this);
        return;
      }
      this.removeAttribute('data-shop-suggest-dismissed');
      if (this.predictiveSearchResults) {
        this.predictiveSearchResults.style.removeProperty('display');
      }
      return origOpen.call(this);
    };

    var origSelect = Ctor.prototype.selectOption;
    Ctor.prototype.selectOption = function () {
      if (activateSelectedSuggest(this)) return;
      origSelect.call(this);
    };

    Ctor.prototype.onFocusOut = function () {
      var self = this;
      var delay = isCoarsePointer() ? 280 : 120;
      setTimeout(function () {
        if (window.__shopSuggestNavigating) return;
        var input = getSearchInput(self) || self.input;
        // User tapped back into the field — keep / reopen suggest
        if (document.activeElement === input) return;
        // Outside dismiss (incl. mid-IME): always close — do not wait for compositionend
        if (isSuggestDismissed() || shouldBlockGhostReopen()) {
          self.isComposing = false;
          clearSuggestSelection(self, { refocus: false, activate: false });
          setSuggestInputActive(self, false);
          self.close(false);
          return;
        }
        if (self.contains(document.activeElement) || document.activeElement === self.input) return;
        if (isInsideSuggestUi(document.activeElement)) return;
        if (isTouchSuggestGuarded()) return;
        // Outside focus loss: end IME flag and close even if composition was active
        self.isComposing = false;
        clearSuggestSelection(self, { refocus: false, activate: false });
        setSuggestInputActive(self, false);
        self.close(false);
      }, delay);
    };

    var origCloseResults = Ctor.prototype.closeResults;
    Ctor.prototype.closeResults = function (clearSearchTerm) {
      setSuggestInputActive(this, false);
      clearSuggestSelection(this, { refocus: false, activate: false });
      var out = origCloseResults.call(this, clearSearchTerm);
      this.removeAttribute('open');
      this.removeAttribute('loading');
      if (this.predictiveSearchResults) {
        if (isSuggestDismissed()) {
          this.predictiveSearchResults.style.display = 'none';
        } else {
          this.predictiveSearchResults.removeAttribute('style');
        }
      }
      return out;
    };

    var origFocus = Ctor.prototype.onFocus;
    Ctor.prototype.onFocus = function () {
      // Ignore focus during outside-close lock (IME may keep/restore focus)
      if (suggestClosedByOutside) return;
      clearSuggestDismissed();
      warmSuggestCache();
      if (isSearchEmpty(this)) {
        this.showSearchHistory();
        return;
      }
      if (typeof this.onChange === 'function') {
        this.onChange();
        return;
      }
      origFocus.call(this);
    };

    Ctor.prototype.showSearchHistory = function () {
      if (shouldBlockGhostReopen()) return;
      var history = getSearchHistory();
      if (!isSearchEmpty(this)) return;
      var markup = buildEmptyFocusMarkup(history);
        this.renderSearchResults(markup);
      var deferred = this.dispatchSearchUpdateEvent('');
      if (deferred) deferred.resolve({ totalCount: history.length });
    };

    Ctor.prototype.onChange = function () {
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(this);
        return;
      }
      if (isSearchEmpty(this)) {
        this.showSearchHistory();
        return;
      }
      var raw = getRawFromInstance(this);
      this.getSearchResults(raw);
    };

    Ctor.prototype.getSearchResults = function (searchTerm) {
      var self = this;
      if (shouldBlockGhostReopen()) {
        forceCloseSuggestPanel(self);
        return;
      }
      var fetchGen = suggestFetchGen;
      var raw = getRawFromInstance(this) || String(searchTerm || '');
      var trimmed = raw.trim();
      var queryKey = raw.replace(/[\s　]+/g, '-').toLowerCase();
      var deferred = this.dispatchSearchUpdateEvent(trimmed);

      // Cache-first: paint before/without waiting on loading chrome when possible
      var provisional = provisionalSuggestFromCache(raw, KEYWORD_SUGGEST_LIMIT);
      if (provisional && provisional.length) {
        var earlyMarkup = buildKeywordMarkup(trimmed, provisional);
        self.renderSearchResults(earlyMarkup);
      } else {
        this.setLiveRegionLoadingState();
      }

      fetchSuggestDebounced(raw, KEYWORD_SUGGEST_LIMIT).then(function (result) {
        if (fetchGen !== suggestFetchGen || shouldBlockGhostReopen()) {
          forceCloseSuggestPanel(self);
          return;
        }
        if (getRawFromInstance(self) !== raw) return;
        var keywords = result.keywords || [];
        // IME / slow mobile: never flash empty over a good provisional paint
        if ((!keywords || !keywords.length) && provisional && provisional.length) {
          keywords = provisional;
        }
        if (self.isComposing && provisional && provisional.length && keywords.length < provisional.length) {
          // Prefer the denser provisional set while IME is still composing
          keywords = applyLocalSuggestRank(
            mergeSuggestEntries(provisional, keywords),
            raw
          ).slice(0, KEYWORD_SUGGEST_LIMIT);
        }
        self.removeAttribute('loading');
        var markup = buildKeywordMarkup(trimmed, keywords);
        self.allPredictiveSearchInstances.forEach(function (i) {
          i.cachedResults[queryKey] = markup;
        });
        self.renderSearchResults(markup);
        // Avoid fighting the mobile keyboard after each suggest paint
        if (!isCoarsePointer()) focusSearchInput(self);
        if (deferred) deferred.resolve({ totalCount: keywords.length });
      });
    };

    Ctor.prototype.onKeydown = function (event) {
      if (isArrowKey(event)) {
        event.preventDefault();
        return;
      }
      if (isEnterKey(event) && getEnterSuggestLabel(this)) {
        event.preventDefault();
        if (Date.now() - lastSuggestEnterAt < 450) return;
        lastSuggestEnterAt = Date.now();
        activateSelectedSuggest(this);
      }
    };

    Ctor.prototype.onKeyup = function (event) {
      if (isArrowKey(event)) {
        event.preventDefault();
        return;
      }
      if (isEnterKey(event) && getEnterSuggestLabel(this)) {
        event.preventDefault();
        // keydown already searched; keep as safety if keydown was IME-swallowed
        if (Date.now() - lastSuggestEnterAt < 450) return;
        lastSuggestEnterAt = Date.now();
        activateSelectedSuggest(this);
        return;
      }
      if (isEnterKey(event)) {
        event.preventDefault();
        // IME composition: let Enter confirm conversion when nothing is selected
        if (isImeProcessKey(event)) return;

        var q = this.__shopGetQueryForSubmit
          ? this.__shopGetQueryForSubmit()
          : this.getQuery();
        if (q && this.__shopSearchSubmit) {
          if (Date.now() - lastSuggestEnterAt < 450) return;
          lastSuggestEnterAt = Date.now();
          this.__shopSearchSubmit(q, 'typed');
        } else if (q) {
          if (Date.now() - lastSuggestEnterAt < 450) return;
          lastSuggestEnterAt = Date.now();
          window.location.assign(searchUrlFor(q));
        }
        return;
      }
      if (event.code === 'Escape' || event.key === 'Escape') {
        if (getSelectedSuggestLabel(this)) {
          event.preventDefault();
          clearSuggestSelection(this);
          return;
        }
        event.preventDefault();
        setSuggestInputActive(this, false);
        this.close(false);
      }
    };

    return true;
  }

  function installSerpEmptyHistory() {
    var root = document.querySelector('[data-shop-serp-empty]');
    var fewTipHost = document.querySelector('.shop-search-serp-tip');
    var history = getSearchHistory()
      .filter(function (label) {
        return isShortKeywordLabel(label);
      })
      .slice(0, 8);

    function fillHistoryList(listEl, items) {
      if (!listEl || !items.length) return false;
      var currentQ = '';
      try {
        currentQ = normalizeSearchQuery(new URLSearchParams(location.search).get('q') || '');
      } catch (e) {}
      var filtered = items.filter(function (label) {
        return normalizeSearchQuery(label).toLowerCase() !== currentQ.toLowerCase();
      });
      if (!filtered.length) return false;
      listEl.innerHTML = filtered
        .map(function (label) {
          return (
            '<li><a href="' +
            escapeHtml(searchUrlFor(label)) +
            '">' +
            escapeHtml(label) +
            '</a></li>'
          );
        })
        .join('');
      return true;
    }

    if (root) {
      var wrap = root.querySelector('[data-shop-serp-history]');
      var list = root.querySelector('[data-shop-serp-history-list]');
      if (wrap && list && fillHistoryList(list, history)) wrap.hidden = false;
    }

    // Few-results: offer history chips under tip (no popular block)
    if (fewTipHost && history.length) {
      var related = document.createElement('div');
      related.className = 'shop-search-serp-related';
      related.setAttribute('data-shop-serp-related', '');
      related.innerHTML =
        '<p class="shop-search-serp-related__title">検索履歴から探す</p>' +
        '<ul class="shop-search-serp-related__list list-unstyled"></ul>';
      var relList = related.querySelector('ul');
      if (fillHistoryList(relList, history)) {
        fewTipHost.insertAdjacentElement('afterend', related);
      }
    }
  }

  function installSerpQueryNormalize() {
    // One-shot per raw query: strip listing-noise tokens from landed SERP URL
    try {
      if (window.location.pathname.indexOf('/search') === -1) return;
      var params = new URLSearchParams(window.location.search);
      var rawQ = params.get('q') || '';
      if (!rawQ) return;
      var cleaned = normalizeSearchQuery(rawQ);
      var compactRaw = String(rawQ).trim().replace(/[\s　]+/g, ' ');
      if (!cleaned || cleaned === compactRaw) return;
      var onceKey = 'figusen_serp_norm_' + compactRaw.toLowerCase();
      if (sessionStorage.getItem(onceKey)) return;
      sessionStorage.setItem(onceKey, '1');
      params.set('q', cleaned);
      if (!params.get('type')) params.set('type', 'product');
      if (!params.get('options[prefix]')) params.set('options[prefix]', 'last');
      window.location.replace('/search?' + params.toString());
    } catch (e) {}
  }

  function installSerpResultObserve() {
    // Observe-only metrics: record landed search result count (never cuts candidates)
    try {
      if (window.location.pathname.indexOf('/search') === -1) return;
      var params = new URLSearchParams(window.location.search);
      var q = params.get('q') || '';
      if (!q) return;
      var empty = !!document.querySelector('.template-search--empty, [data-shop-serp-empty]');
      var countEl = document.querySelector('#ProductCount, #ProductCountDesktop, [data-total-count]');
      var count = 0;
      if (!empty && countEl) {
        var m = String(countEl.textContent || '').match(/(\d+)/);
        if (m) count = parseInt(m[1], 10) || 0;
      }
      postSuggestStats(q, 0, empty ? 0 : Math.max(count, 1));
    } catch (e) {}
  }

  function installSuggestViewportFit() {
    if (window.__shopSuggestViewportFit) return;
    window.__shopSuggestViewportFit = true;
    function apply() {
      try {
        var vv = window.visualViewport;
        var layoutH = window.innerHeight || 0;
        var h = vv && vv.height ? vv.height : layoutH;
        var keyboardOpen = isCoarsePointer() && layoutH > 0 && h < layoutH * 0.82;
        // When keyboard is open, keep panel shorter so candidates stay tappable
        var ratio = keyboardOpen ? 0.34 : isCoarsePointer() ? 0.4 : 0.45;
        var hardCap = keyboardOpen ? 240 : isCoarsePointer() ? 300 : 360;
        var maxPx = Math.max(140, Math.min(Math.round(h * ratio), hardCap));
        document.documentElement.style.setProperty('--shop-suggest-scroll-max', maxPx + 'px');
        var rowH = isCoarsePointer() ? 52 : 48;
        var histRows = keyboardOpen ? 4 : 5;
        var histMax = Math.min(histRows * rowH, Math.round(h * (keyboardOpen ? 0.3 : 0.36)));
        histMax = Math.max(rowH * 3, histMax);
        document.documentElement.style.setProperty('--shop-history-scroll-max', histMax + 'px');
        document.documentElement.classList.toggle('shop-suggest-keyboard-open', !!keyboardOpen);
      } catch (e) {}
    }
    apply();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', apply);
      window.visualViewport.addEventListener('scroll', apply);
    }
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', function () {
      setTimeout(apply, 120);
      setTimeout(apply, 400);
    });
  }

  function installSuggestOpsProbe() {
    // Ops helper: console or bookmarklet — observe only, never deletes candidates
    if (window.figusenSuggestHealth) return;
    window.figusenSuggestHealth = function (days) {
      var base = supaBase();
      if (!base) return Promise.reject(new Error('Supabase config missing'));
      return fetch(base + '/rest/v1/rpc/suggest_health_report', {
        method: 'POST',
        headers: apiHeaders(),
        body: JSON.stringify({ p_days: Math.min(Math.max(days || 7, 1), 30) }),
        mode: 'cors'
      })
        .then(function (r) {
          if (!r.ok) throw new Error('health HTTP ' + r.status);
          return r.json();
        })
        .then(function (data) {
          try {
            console.groupCollapsed('[figusen] suggest health');
            console.log(data);
            if (data && data.stats) console.table(data.stats);
            if (data && data.ops) console.table(data.ops);
            console.groupEnd();
          } catch (e) {}
          return data;
        });
    };
  }

  function installBrowseAndLikePersonalization() {
    if (window.__shopBrowseLearnInstalled) return;
    window.__shopBrowseLearnInstalled = true;

    // Product detail: learn from current title (browse signal)
    try {
      var productTitle =
        (document.querySelector('meta[property="og:title"]') || {}).content ||
        (document.querySelector('.product__title, h1.product__title, .product__title h1') || {}).textContent ||
        '';
      productTitle = String(productTitle || '')
        .replace(/\s*[|｜].*$/, '')
        .trim();
      if (productTitle.length >= 2 && productTitle.length <= 28 && /\/products\//.test(location.pathname)) {
        bumpLocalLearn(productTitle, 'product');
      } else if (productTitle.length > 28 && /\/products\//.test(location.pathname)) {
        // Learn short tokens only — never full SKU titles
        splitTerms(productTitle).forEach(function (tok) {
          if (isShortKeywordLabel(tok)) bumpLocalLearn(tok, 'typed');
        });
      }
    } catch (e) {}

    // Like / favorite button → stronger personal rank
    document.addEventListener(
      'click',
      function (event) {
        var fav = event.target.closest('.custom-wk-btn, [aria-label="いいね"], [data-wishlist], .wishlist-button');
        if (!fav) return;
        var card = fav.closest('.card-wrapper, .product-card-wrapper, .product, product-info, .product__info-container');
        var titleEl = card
          ? card.querySelector('.card__heading a, .card__heading, .product__title, h1')
          : document.querySelector('.product__title, h1.product__title');
        var title = titleEl ? String(titleEl.textContent || '').trim() : '';
        if (title.length >= 2) bumpLocalLearn(title, 'suggest');
      },
      true
    );
  }

  function boot() {
    loadSuggestCacheFromSession();
    seedLocalLearnFromHistory();
    syncHistoryFromCloud();
    installSearchLearning();
    installBrowseAndLikePersonalization();
    installSerpQueryNormalize();
    installSerpEmptyHistory();
    installSerpResultObserve();
    installSuggestViewportFit();
    installSuggestOpsProbe();
    installGlobalSuggestKeys();
    var scheduleWarm = function () {
      if (typeof requestIdleCallback === 'function') {
        requestIdleCallback(function () {
          warmSuggestCache();
        }, { timeout: 1800 });
      } else {
        setTimeout(warmSuggestCache, 700);
      }
    };
    scheduleWarm();
    if (patchPredictiveSearch()) {
      document.querySelectorAll('predictive-search').forEach(function (el) {
        el.isComposing = false;
        installChipSearch(el);
      });
      return;
    }
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (patchPredictiveSearch()) {
        clearInterval(t);
        document.querySelectorAll('predictive-search').forEach(function (el) {
          el.isComposing = false;
          installChipSearch(el);
        });
      } else if (n > 50) {
        clearInterval(t);
      }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
